"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var cnpj_1 = require("./cnpj");

var cpf_1 = require("./cpf");

var document_1 = require("./document");

var money_1 = require("./money");

var phone_1 = require("./phone");

var zipcode_1 = require("./zipcode");

var masks = [tslib_1.__assign({
  name: 'zipcode'
}, zipcode_1.default), tslib_1.__assign({
  name: 'phone'
}, phone_1.default), tslib_1.__assign({
  name: 'document'
}, document_1.default), tslib_1.__assign({
  name: 'cpf'
}, cpf_1.default), tslib_1.__assign({
  name: 'cnpj'
}, cnpj_1.default), tslib_1.__assign({
  name: 'money'
}, money_1.default)];
exports.default = masks;